const ar = [
    {
        value: 1,
        text: 'Venta'
    },
    {
        value: 2,
        text: 'Alquiler'
    },
    {
        value: 3,
        text: 'Alquiler Temporario'
    },
    {
        value: 4,
        text: 'Permuta'
    },
    {
        value: 6,
        text: 'Compartir'
    }
]

const es = [
    {
        value: 1,
        text: 'Venta'
    },
    {
        value: 2,
        text: 'Alquiler'
    },
    {
        value: 3,
        text: 'Alquiler Vacacional'
    },
    {
        value: 4,
        text: 'Permuta'
    },
    {
        value: 5,
        text: 'Traspaso'
    },
    {
        value: 6,
        text: 'Compartir'
    }
]

const uy = [
    {
        value: 1,
        text: 'Venta'
    },
    {
        value: 2,
        text: 'Alquiler'
    },
    {
        value: 3,
        text: 'Alquiler Temporada'
    },
    {
        value: 4,
        text: 'Permuta'
    },
    {
        value: 6,
        text: 'Compartir'
    }
]

const cl = [
    {
        value: 1,
        text: 'Venta'
    },
    {
        value: 2,
        text: 'Arriendo'
    },
    {
        value: 3,
        text: 'Arriendo Temporal'
    },
    {
        value: 4,
        text: 'Permuta'
    },
    {
        value: 6,
        text: 'Compartir'
    }
]

export default {
    ar,
    es,
    uy,
    cl
}
